/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountingEnumDto {
  DANISH = 'Danish',
  GERMAN = 'German',
}
